module.exports = __webpack_public_path__ + "img/11-small.4ade0856.png";